import axios from "axios";
export var extractApiErrorMessage = function (error, fallbackMessage) {
    var _a, _b, _c;
    if (!axios.isAxiosError(error)) {
        return fallbackMessage;
    }
    var responseData = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
    var friendlyDescription = String(((_b = responseData === null || responseData === void 0 ? void 0 : responseData.friendly) === null || _b === void 0 ? void 0 : _b.description) || (responseData === null || responseData === void 0 ? void 0 : responseData.description) || "").trim();
    if (friendlyDescription) {
        return friendlyDescription;
    }
    var friendlyName = String(((_c = responseData === null || responseData === void 0 ? void 0 : responseData.friendly) === null || _c === void 0 ? void 0 : _c.name) || (responseData === null || responseData === void 0 ? void 0 : responseData.name) || "").trim();
    if (friendlyName) {
        return friendlyName;
    }
    var message = String((responseData === null || responseData === void 0 ? void 0 : responseData.message) || "").trim();
    if (message) {
        return message;
    }
    var errorMessage = String((responseData === null || responseData === void 0 ? void 0 : responseData.error) || "").trim();
    if (errorMessage) {
        return errorMessage;
    }
    var responseErrors = responseData === null || responseData === void 0 ? void 0 : responseData.errors;
    if (responseErrors && typeof responseErrors === "object") {
        for (var key in responseErrors) {
            if (!Object.prototype.hasOwnProperty.call(responseErrors, key)) {
                continue;
            }
            var firstError = responseErrors[key];
            if (Array.isArray(firstError) && typeof firstError[0] === "string") {
                return firstError[0];
            }
            if (typeof firstError === "string" && firstError.trim().length > 0) {
                return firstError;
            }
        }
    }
    return fallbackMessage;
};
